import { Copy, Warning } from "@phosphor-icons/react"
import { Button, IconButton } from "~/components/design-system/components"
import { Tooltip } from "~/components/reusable/Tooltip"

const AuthError = ({ error }: { error?: Error }) => {
  const errorTitle = "Authentication Error"
  const errorMessage = "Error happened while authenticating. Please try again."
  const exactMessage = error?.message ?? ""
  const userMessage =
    "Please make sure the account is part of an organization. If you need to be assigned to one, contact your system administrator or Hakio."

  const fullErrorObject = {
    message: error?.message || errorMessage,
    name: error?.name,
    stack: error?.stack,
    cause: error?.cause,
    ...(error && typeof error === "object"
      ? Object.fromEntries(
          Object.entries(error).filter(
            ([key]) => !["message", "name", "stack", "cause"].includes(key),
          ),
        )
      : {}),
  }

  const handleCopyError = () => {
    const errorString = JSON.stringify(fullErrorObject, null, 2)
    navigator.clipboard.writeText(errorString)
  }

  return (
    <div className="flex h-viewport-height items-center justify-center flex-col gap-4 bg-subtle">
      <div className="flex flex-col rounded-[16px] shadow-modal bg-base w-[550px]">
        <div className="flex flex-col gap-5 p-5">
          <div className="flex items-center justify-center w-[32px] h-[32px] rounded-full bg-red-600">
            <Warning size={20} className="text-white" />
          </div>
          <div className="flex flex-col gap-1">
            <span className="label-lg">{errorTitle}</span>
            <p className="paragraph-base text-fg-subtle">
              {errorMessage}
              <br />
              <br />
              {userMessage}
            </p>
          </div>
          {exactMessage && (
            <div className="bg-subtle rounded-[12px] border border-base p-4 max-h-[150px] overflow-y-auto relative">
              <div className="absolute right-3 top-2.5 flex gap-2 z-10">
                <Tooltip title="Copy error to clipboard">
                  <IconButton
                    onClick={handleCopyError}
                    title="Copy error to clipboard"
                    variant="neutral"
                  >
                    <Copy size={16} />
                  </IconButton>
                </Tooltip>
              </div>
              <p className="paragraph-base text-fg-subtle whitespace-pre-wrap break-words text-left">
                {exactMessage}
              </p>
            </div>
          )}
        </div>
        <div className="flex flex-row gap-3 items-center justify-between bg-subtle px-5 py-4 rounded-b-[16px] border-t border-base">
          <Tooltip title="support@hakio.com">
            <Button href="mailto:support@hakio.com" variant="transparent">
              Contact Support
            </Button>
          </Tooltip>
          <div className="flex justify-end w-full gap-3">
            <Button onClick={() => window.location.reload()} variant="neutral">
              Refresh Page
            </Button>
            <Button onClick={() => (window.location.href = "/logout")}>Try Again</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthError
